import {
  FormTemplate,
  FormTemplateSection
} from 'data/template/template.types';
import cloneDeep from 'lodash.clonedeep';
import setAllFieldsAsReadOnlyExcludingFields from 'shared/form/fields/setAllFieldsAsReadOnlyExcludingFields';

export default function adaptTemplateVisibilityMode(
  template: FormTemplate,
  mode: 'create' | 'edit' | 'view' | 'copy'
): FormTemplate {
  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }
  clonedTemplate.key = Date.now().toString();
  clonedTemplate.formId = Date.now().toString();
  return clonedTemplate;
}
